import axios from 'axios';

import { RequestPerformer } from '../types';
import { createRequestInstance } from './logic/createRequestInstance';

export const networkRequest = createRequestInstance(
  axios.create({
    paramsSerializer: (params) =>
      Object.entries(params ?? {})
        .filter(([, v]) => v !== null && v !== undefined)
        .reduce((sp, [key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((v) => sp.append(key, String(v)));
          } else {
            sp.append(key, String(value));
          }
          return sp;
        }, new URLSearchParams())
        .toString(),
  }).request as RequestPerformer,
);
